import React, { useEffect, useState } from 'react';

const icon = (children) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>
);
const ICONS = {
  play: icon(<path d="M7 4.5v15l12-7.5-12-7.5z" />),
  stop: icon(<rect x="5.5" y="5.5" width="13" height="13" rx="1.5" fill="currentColor" />),
  copy: icon(<><rect x="9" y="9" width="11" height="11" rx="2" /><path d="M5 15V6a2 2 0 0 1 2-2h9" /></>),
  copied: icon(<path d="M5 12.5l4.5 4.5L19 7.5" />),
  share: icon(<><circle cx="18" cy="5.5" r="2.5" /><circle cx="6" cy="12" r="2.5" /><circle cx="18" cy="18.5" r="2.5" /><path d="M8.2 10.8l7.6-4.1M8.2 13.2l7.6 4.1" /></>),
  download: icon(<><path d="M12 4v11M7.5 11l4.5 4.5 4.5-4.5" /><path d="M5 19.5h14" /></>),
};

/**
 * The answer, in a box with its actions under it — the result box of
 * app.palefo.com (its .engine-result), to that box's measurements: play, stop,
 * copy, share, download, and the voice's name at the right.
 *
 * `onDownload` and `onShare` are omitted when there is nothing to offer;
 * `aside`, when given, takes the place of the voice's name.
 */
export default function AnswerBox({ text, heard, playing, canPlay, onPlay, onStop, onCopy, onShare, onDownload, speaker, aside, t }) {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 1600);
    return () => clearTimeout(timer);
  }, [copied]);

  const action = (name, label, onClick, disabled) => (
    <button className="answer-btn" type="button" onClick={onClick} disabled={disabled} aria-label={label} title={label}>
      {ICONS[name]}
    </button>
  );

  return (
    <div className="answer" data-playing={playing || undefined}>
      {heard && <p className="answer-heard"><span>{t('heard')}</span> «{heard}»</p>}
      <p className="answer-text">{text}</p>
      <div className="answer-actions">
        {action('play', t('dock.hear'), onPlay, !canPlay || playing)}
        {action('stop', t('dock.stop'), onStop, !playing)}
        {action(copied ? 'copied' : 'copy', t(copied ? 'box.copied' : 'box.copy'), async () => setCopied(await onCopy()))}
        {onShare && action('share', t('box.share'), onShare)}
        {onDownload && action('download', t('box.download'), onDownload, !canPlay)}
        {aside || (speaker && <span className="answer-speaker">{speaker}</span>)}
      </div>
    </div>
  );
}
